<template>
  <div>
    <div v-if="drawRatePermission !== 0" class="bid-concession-rate">
      <template>
        <span v-if="!hideTip" style="margin-right: 10px;">中标让利率 = 【{{ bidConcessionRate ? bidConcessionRate : '' }}】%</span>
        <el-button
          type="primary"
          @click="handleDrawBidConcessionRate"
        >抽取中标让利率</el-button>
      </template>
      <!-- 抽签方式 dialog -->
      <el-dialog
        class="draw-type-dialog"
        :title="drawTypeDialog.title"
        :visible.sync="drawTypeDialog.visible"
        append-to-body
        modal-append-to-body
        destroy-on-close
        :close-on-click-modal="false"
        width="600px"
        v-loading="drawTypeDialog.loading"
      >
        <el-form :model="drawTypeDialog.form" :rules="drawTypeDialog.form.rules">
          <el-form-item prop="drawType" class="draw-type">
            <el-radio-group v-model="drawTypeDialog.form.drawType">
              <el-radio
                v-for="item in drawTypeDialog.drawTypeOptions"
                :label="item.id"
                :key="item.id"
              >
                <el-tooltip placement="top">
                  <div slot="content">{{ item.message }}</div>
                  <span>{{ item.value }}</span>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <p class="red take-care">注：请谨慎选择抽签方式，提交后不允许再修改。</p>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmitDrawType">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 线上抽签 dialog -->
      <el-dialog
        custom-class="online-dialog"
        title="抽签设置"
        :visible.sync="onlineDialog.visible"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="1200px"
        destroy-on-close
        :before-close="handleOnlineDialogClose"
        v-loading="onlineDialog.loading"
      >
        <div class="dialog-content-wrapper">
          <section class="section-box content-left">
            <p class="title">设置</p>
            
            <div class="setting-types">
              <el-button v-if="!isDraw || drawConfig.numberType === 1" :type="drawConfig.numberType === 1 ? 'primary' : 'default'" @click="handleType(1)">输入范围</el-button>
              <el-button v-if="!isDraw || drawConfig.numberType !== 1" :type="drawConfig.numberType === 2 ? 'primary' : 'default'" @click="handleType(2)">输入数值</el-button>
            </div>

            <div class="setting-content">
              <!-- 设置 - 输入范围 -->
              <setting-area
                v-if="!isDraw || drawConfig.numberType === 1"
                v-show="drawConfig.numberType === 1"
                :disabled="isDraw"
                :config="drawConfig"
                :default-draw-numbers="areaDrawNumbers"
                @submit="handleAddRatePool"
              />

              <!-- 设置 - 数值方式 -->
              <el-form
                v-if="!isDraw || drawConfig.numberType !== 1"
                v-show="drawConfig.numberType === 2"
                :model="onlineDialog.form"
                :rules="onlineDialog.form.rules"
                :disabled="isDraw"
              >
                <el-form-item prop="drawCountLimit">
                  请设置抽取
                  <el-input-number
                    class="count-limit"
                    v-model="onlineDialog.form.drawCountLimit"
                    disabled
                    size="mini"
                  ></el-input-number>
                  个
                </el-form-item>
                <el-form-item prop="rateItem" label-position="top" label="请输入参与抽签的值">
                  <el-row :gutter="20">
                    <el-col :span="18">
                      <el-input
                        class="add-rate-item"
                        v-model="onlineDialog.form.rateItem"
                      ></el-input>
                    </el-col>
                    <el-col :span="6">
                      <el-button :disabled="isDraw || !onlineDialog.form.rateItem" @click="addRateItem">添加</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
              <div class="draw-rate-box" v-show="drawConfig.numberType === 2">
                <el-tag
                  class="draw-item"
                  v-for="rate in isDraw ? 
                    onlineDialog.drawPool :
                    onlineDialog.drawRateList
                  "
                  :key="rate"
                  :closable="isDraw ? false : true"
                  @close="deleteRateItem(rate)"
                >{{ rate }}</el-tag>
              </div>
              <div class="add-draw-rate-pool" v-show="drawConfig.numberType === 2">
                <el-button
                  @click="addRateItemToDrawPool"
                  type="primary"
                  :disabled="isDraw || !onlineDialog.drawRateList.length"
                >加入抽奖池</el-button>
              </div>
            </div>
          </section>
          <section class="arrow">
            <img src="../../../assets/images/arrow_draw_dialog.png" alt="" />
          </section>
          <section class="section-box content-right">
            <p class="title">抽签池</p>
            <!-- 如果是线上抽签，且添加抽奖池之后显示 -->
            <p v-if="onlineDialog.drawStep !== 0 && drawType === 0">
              <span v-if="onlineDialog.drawPool.length">
                从【{{ onlineDialog.drawPool.length }}】个值中抽【{{ onlineDialog.form.drawCountLimit }}】个
              </span>
            </p>
            <div class="number-pond-wrapper">
              <div v-if="onlineDialog.drawStep === 3" class="drawed-list">
                <div
                  v-for="item in onlineDialog.drawResults"
                  :key="item"
                  class="drawed-item"
                >
                  {{ item }}
                </div>
              </div>
              <number-pond :isDraw="isDraw" ref="numberPond" />
            </div>
            <div class="draw-btn-wrapper">
              <el-button
                style="z-index: 999;"
                type="primary"
                :disabled="onlineDialog.drawStep !== 1" 
                @click="startDraw"
              >开始抽签</el-button>
              <el-button
                style="z-index: 999;"
                :disabled="onlineDialog.drawStep !== 2" 
                type="primary"
                @click="endDraw"
              >停止抽签</el-button>
              <el-button
                style="z-index: 999;"
                type="primary"
                @click="consoleDrawResult"
              >打印抽签结果表</el-button>
            </div>
          </section>
        </div>
      </el-dialog>
      <!-- 线下抽签 dialog -->
      <el-dialog
        class="offline-dialog"
        :title="offlineDialog.title"
        :visible.sync="offlineDialog.visible"
        append-to-body
        modal-append-to-body
        destroy-on-close
        :close-on-click-modal="false"
        width="500px"
        v-loading="offlineDialog.loading"
      >
        <div class="dialog-content">
          <el-form
            :disabled="isDraw"
            :model="offlineDialog.form"
            :rules="offlineDialog.form.rules"
          >
            <el-form-item
              prop="bidConcessionRate"
              class="off-bid-concession-rate"
              label="中标让利率"
            >
              <el-input
                v-model="offlineDialog.form.bidConcessionRate"
                placeholder="请输入线下抽签结果" 
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmitOfflineDraw">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import NumberPond from "../../NumberPond/index.vue";
import SettingArea from "./SettingArea.vue";

export default {
  components: {
    NumberPond,
    SettingArea
  },

  props: {
    drawLimit: {
      type: Number,
      default: 0
    },
    hideTip: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // 抽签方式配置
    const drawTypeOptions = [
      {
        id: 0,
        value: '线上抽签',
        message: '在线抽取工具抽取，抽取结果自动回填系统',
      },
      {
        id: 1,
        value: '线下抽签',
        message: '线下工具抽取后，录入抽签结果',
      }
    ];
    // 提取抽签方式可选校验值
    const drawTypeLabels = drawTypeOptions.map(item => item.id);
    // 抽签方式选项校验
    const checkDrawType = (rule, value, callback) => {
      if (!drawTypeLabels.includes(value)) {
        callback(new Error('请选择抽签方式'));
      } else {
        callback();
      }
    };
    const checkRateItem = (rule, value, callback) => {
      const req = /^\d+(\.\d{1,3})?$/;
      if (!req.test(value)) {
        callback(new Error('请输入正确的数字，小数最多输入三位'));
      } else if (Number(value) > 100) {
        callback(new Error('数值最大为100， 请确认'));
      } else {
        callback();
      }
    };
    return {
      bidConcessionRate: 0, // 中标让利率
      drawType: 2, // 抽签方式 0:线上抽签 1:线下抽签 2:未选择
      drawRatePermission: 0, // 0:不可见　1:可编辑　2:可查看
      drawTypeDialog: {
        title: '设置抽签方式',
        visible: false,
        drawTypeOptions,
        loading: false,
        form: {
          drawType: null,
          rules: {
            drawType: [
              { validator: checkDrawType, trigger: 'blur' },
            ],
          },
        },
      },
      onlineDialog: {
        title: '线上抽签设置',
        visible: false,
        loading: false,
        form: {
          drawCountLimit: 1,
          rateItem: '',
          rules: {
            drawCountLimit: [
              { required: true, message: '请设置抽取个数', trigger: 'blur' }
            ],
            rateItem: [
              { validator: checkRateItem, trigger: 'blur' },
            ],
          }
        },
        drawRateList: [],
        drawPool: [], // 抽奖池
        drawResults: [], // 抽奖结果
        drawStep: 0, // 抽签步骤 0:未开始 1:添加抽签池 2:开始抽签 3:抽签完成
      },
      offlineDialog: {
        title: '线下抽签结果录入',
        visible: false,
        form: {
          bidConcessionRate: '',
          rules: {
            bidConcessionRate: [
              { required: true, message: '请输入线下抽签结果', trigger: 'blur' },
              { validator: checkRateItem, trigger: 'blur' },
            ],
          },
        },
        loading: false,
      },

      // 当前输入类型
      drawConfig: {
        numberType: 1 // 1: 输入范围 2: 输入数值
      },
      areaDrawNumbers: [] // 默认已抽签的数值列表
    }
  },

  computed: {
    // 是否已抽签
    isDraw() {
      // drawRatePermission 0:不可见　1:可编辑　2:可查看
      // onlineDialog.drawStep: 0:未开始 1:添加抽签池 2:开始抽签 3:抽签完成
      return this.drawRatePermission === 2 || [2, 3].includes(this.onlineDialog.drawStep);
    }
  },

  created() {
    // 查看抽签方式
    this.getDrawRateType();
    // 获取中标让利率抽签按钮的状态
    this.getDrawRateButtonStatus();
    // 获取中标让利率抽取详情
    this.getDrawRateDetail();
  },

  methods: {
    // 查看抽签方式
    async getDrawRateType() {
      const res = await this.$api.getDrawRateType();
      if (!res.data.meta.success) {
        throw new Error(res.data.meta.message);
      }
      this.drawType = res.data.data;
    },
    // 获取中标让利率抽签按钮的状态
    async getDrawRateButtonStatus() {
      const res = await this.$api.getDrawRateButtonStatus();
      if (!res.data.meta.success) {
        throw new Error(res.data.meta.message);
      }
      this.drawRatePermission = res.data.data;
    },
    // 获取中标让利率抽取详情
    async getDrawRateDetail() {
      try {
        const res = await this.$api.getDrawRateDetail();
        const {
          drawResult = '',
          drawPool = '',
          isOnline = null,
          status = 0,
          numberType = null,
          numberStart = null,
          numberEnd = null,
          numberInterval = null,
        } = res.data?.data || {};
        this.drawType = isOnline === null ? 2 : isOnline ? 0 : 1; // 如果是null则是未抽取，如果是true则是线上，如果是false则是线下
        if (status === 1) {
          this.onlineDialog.drawStep = 3;
        }

        // 如果是线上
        if (this.drawType === 0) {
          this.onlineDialog.drawPool = drawPool.split(',');
          this.onlineDialog.drawResults = [drawResult];
          this.bidConcessionRate = drawResult;
          
          if (this.isDraw) {
            if (numberType === 1) { // 输入范围
              this.drawConfig = {
                numberType,
                numberStart: Number(numberStart),
                numberEnd: Number(numberEnd),
                numberInterval: Number(numberInterval),
                drawCountLimit: 1
              }
              this.areaDrawNumbers = this.onlineDialog.drawPool;
              console.log(this.drawConfig)
            } else { // 输入数值
              this.drawConfig = { numberType: 2 }
            }
          }
        }
        // 如果是线下
        if (this.drawType === 1) {
          this.offlineDialog.form.bidConcessionRate = drawResult;
          this.bidConcessionRate = drawResult;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 抽取中标让利率点击事件
    async handleDrawBidConcessionRate() {
      await this.getDrawRateType();
      // 获取中标让利率抽取详情
      await this.getDrawRateDetail();
      switch (this.drawType) {
        // 如果是线上抽签，则打开线上抽签对话框
        case 0: this.onlineDialog.visible = true; break;
        // 如果是线下抽签，则打开线下抽签对话框
        case 1: this.offlineDialog.visible = true; break;
        // 如果是未选择抽签方式，则打开抽签方式对话框
        case 2: this.drawTypeDialog.visible = true; break;
        default: break;
      }
    },
    // 提交抽取方式点击事件
    async handleSubmitDrawType() {
      this.drawTypeDialog.visible = false;
      const drawType = this.drawTypeDialog.form.drawType; // 选择的抽签方式
      let isOffline = true; // 默认是线上
      switch (this.drawTypeDialog.form.drawType) {
        // 线上
        case 0: isOffline = true; break;
        // 线下
        case 1: isOffline = false; break;
        default: break;
      }
      // 提交抽签方式
      const res = await this.$api.postDrawRateType(isOffline);
      if (!res.data.meta.success) {
        this.$message.error(res.data.meta.message);
        throw new Error(res.data.meta.message);
      }
      this.$message.success('抽签方式设置成功！');
      // 根据抽签方式，打开抽签 dialog
      switch (drawType) {
        case 0: this.openOnlineDialog(); break;
        case 1: this.openOfflineDialog(); break;
        default:  break;
      }
    },
    // 打开线上抽签对话框
    openOnlineDialog() {
      this.onlineDialog.visible= true;
      // 获取中标让利率抽取详情
      this.getDrawRateDetail();
    },
    // 打开线下抽签对话框
    openOfflineDialog() {
      this.offlineDialog.visible= true;
      // 获取中标让利率抽取详情
      this.getDrawRateDetail();
    },
    // 提交线下抽签中标让利率
    async handleSubmitOfflineDraw () {
      const req = /^\d+(\.\d{1,3})?$/;
      if (!req.test(this.offlineDialog.form.bidConcessionRate)) {
        this.$message.error('请输入正确的数字，小数最多输入三位');
        return;
      } else if (Number(this.offlineDialog.form.bidConcessionRate) > 100) {
        this.$message.error('数值最大为100， 请确认');
        return;
      }
      this.bidConcessionRate = this.offlineDialog.form.bidConcessionRate;
      // 调用接口保存中标让利率
      const params = {
        drawResult: this.offlineDialog.form.bidConcessionRate,
      };
      const res = await this.$api.doDrawRateOffline(params);
      if (!res.data.meta.success) {
        throw new Error(res.data.meta.message);
      }
      this.$message.success('中标让利率提交从成功！');
      this.onlineDialog.drawStep = 3; // 更新步骤为抽签完成
      this.offlineDialog.visible= false;
      this.offlineDialog.form.bidConcessionRate= ''
    },
    // 开始抽签
    startDraw() {
      if (this.onlineDialog.drawPool.length === 0) {
        this.$message.error('当前抽奖池没有数值，请确认');
        return;
      }
      this.onlineDialog.drawStep = 2; // 更新步骤为开始抽签
    },
    // 结束抽签
    async endDraw() {
      const { numberType, numberStart, numberEnd, numberInterval } = this.drawConfig
      // 提交结果
      const params = {
        numberType,
        drawCount: this.onlineDialog.form.drawCountLimit,
        drawPool: this.onlineDialog.drawPool,
      };
      if (numberType === 1) {
        params.numberStart = numberStart;
        params.numberEnd = numberEnd;
        params.numberInterval = numberInterval;
      }
      console.log('endDraw drawConfig:', this.drawConfig)
      console.log('endDraw params:', params)
      
      const res = await this.$api.doDrawRate(params);
      if (res.data.meta.success) {
        // 更新状态
        this.onlineDialog.drawStep = 3; // 更新步骤为抽签完成
        this.$refs.numberPond.speed();
        // 获取结果
        const { drawResult = '' } = res?.data?.data || {};
        this.onlineDialog.drawResults = [drawResult] || [];
        this.bidConcessionRate = Number(this.onlineDialog.drawResults[0]) || 0;
      } else {
        this.$message({
          type: 'error',
          message: res?.data?.meta?.message || '请求失败，请稍后重试~'
        });
      }
    },
    // 查看抽签结果
    async consoleDrawResult() {
      const res = await this.$api.postDrawRateResultFile();
      if (res?.status === 200) {
        let blob = new Blob([res.data], {
          type: "application/pdf",
        });
        let url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        this.$message({
          type: "error",
          message: res?.data?.meta?.message || "请求失败，请稍后重试~",
        });
      }
    },
    // 关闭线上抽签对话框事件处理函数
    handleOnlineDialogClose(done) {
      if (this.onlineDialog.drawStep !== 3) {
        this.$confirm('请先停止抽签再进行关闭，强制关闭后抽签记录不保留', '提示', {
          confirmButtonText: '强制关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'error',
            message: '关闭成功!'
          });
          this.drawConfig.numberType = 1;
          this.onlineDialog.drawStep = 1;
          this.$emit('close');
          done();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      } else {
        this.$emit('close');
        done();
      }
    },
    // 添加中标让利润抽签项
    addRateItem() {
      if (this.onlineDialog.form.rateItem === '' || this.onlineDialog.form.rateItem === undefined) {
        this.$message.error('请先输入值后再添加');
        return;
      }
      if (this.onlineDialog.drawRateList.indexOf(this.onlineDialog.form.rateItem) !== -1) {
        this.$message.error('您已添加该数值，请确认');
        return;
      }
      if (this.onlineDialog.drawPool.indexOf(this.onlineDialog.form.rateItem) !== -1) {
        this.$message.error('抽签池中已拥有该数值，请确认');
        return;
      }
      const req = /^\d+(\.\d{1,3})?$/;
      if (!req.test(this.onlineDialog.form.rateItem)) {
        this.$message.error('请输入正确的数字，小数最多输入三位');
        return;
      } else if (Number(this.onlineDialog.form.rateItem) > 100) {
        this.$message.error('数值最大为100， 请确认');
        return;
      }
      this.onlineDialog.drawRateList.push(this.onlineDialog.form.rateItem);
      this.onlineDialog.form.rateItem = '';
    },
    addRateItemToDrawPool() {
      // 如果当前没有数据，则禁止添加
      if (!this.onlineDialog.drawRateList.length) {
        this.$message.error('添加失败，当前没有数据');
      }
      // 待加入抽签池的抽签数组和抽签池的交集，如果交集的length为0,说明没有重复的，则允许添加
      const union = this.onlineDialog.drawPool.filter(item => this.onlineDialog.drawRateList.includes(item));
      if (union.length) {
        this.$message.error('添加失败，数值重复，请勿重复添加');
      } else {
        this.onlineDialog.drawStep = 1; // 更新步骤为添加抽签池
        this.onlineDialog.drawPool.push(...this.onlineDialog.drawRateList);
        this.$message.success('添加成功');
        // this.drawRatePermission = 2;
      }
    },
    
    // 删除中标让利润抽签项
    deleteRateItem(rate) {
      this.onlineDialog.drawRateList.splice(this.onlineDialog.drawRateList.indexOf(rate), 1);
    },

    // 切换输入类型
    handleType(type) {
      if (this.isDraw) return;
      this.drawConfig.numberType = type;
      this.onlineDialog.drawPool = [];
    },
    // 添加数值到待抽取列表
    handleAddRatePool(numbers, { min, max, step }) {
      console.log('handleAddRatePool', { min, max, step })
      this.drawConfig = {
        ...this.drawConfig,
        numberStart: min,
        numberEnd: max,
        numberInterval: step
      }
      console.log('handleAddRatePool', this.drawConfig)
      this.onlineDialog.drawPool = [...numbers];
      this.onlineDialog.drawStep = 1; // 更新步骤为添加抽签池
      this.$message.success('添加成功');
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-concession-rate {
  height: 48px;
  line-height: 48px;
  margin-bottom: 10px;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.draw-type-dialog {
  .draw-type {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .el-radio {
      margin: 0 80px;
      font-size: 16px;
    }
  } 
}
.take-care {
  text-align: center;
}
.dialog-content-wrapper {
  width: 1150px;
  height: 460px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .section-box {
    width: 550px;
    height: 460px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(15, 108, 203, 0.1);
    border-radius: 0px 0px 0px 0px;
    padding: 16px 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      color: #0060b2;
      font-size: 16px;
    }
  }
  .content-left {
    .count-limit {
      width: 100px;
    }
    .add-rate-item {
      width: 100%;
    }
    .draw-rate-box {
      width: 100%;
      height: 100%;
      overflow: auto;
      width: 500px;
      height: 145px;
      background: rgba(15, 108, 203, 0.05);
      border-radius: 0px 0px 0px 0px;
      padding: 10px;
      margin-top: 10px;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .draw-item {
        margin-bottom: 10px;
        margin-right: 20px;
        background-color: #bfe2ff66;
      }
    }
    .add-draw-rate-pool {
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
  }
  .content-right {
    .draw-btn-wrapper {
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 20px;
      z-index: 999;
    }
    .number-pond-wrapper {
      width: 432px;
      height: 290px;
      display: flex;
      justify-content: center;
      position: relative;
      .drawed-list {
        width: 432px;
        height: 290px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        flex-direction: column;
        .drawed-item {
          height: 36px;
          font-weight: 400;
          font-size: 36px;
          color: #0f6ccb;
          line-height: 36px;
          margin-bottom: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          text-align: center;
        }
        .drawed-item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.setting-content {
  height: calc(100% - 80px);
}
</style>